import { defineComponent } from 'vue';
import styles from './index.module.scss';
import LinkList, { ILinkItem } from './LinkList';
import { genStaticUrl } from '@dts/shared/src/utils/httpUrlConfig';
import { useModalStore } from '@/store/modal';

const Footer = defineComponent({
  setup() {
    const dtsFooterLogo = genStaticUrl('eraImages/dts-footer-logo.png');
    const modal = useModalStore();
    const linkArr: ILinkItem[] = [
      {
        title: 'Contact us',
        items: [
          {
            link: 'DataTransformationOfficeCN@bmw-brilliance.cn',
            href: 'mailto:DataTransformationOfficeCN@bmw-brilliance.cn',
            target: '',
          },
        ],
      },
      {
        title: 'Quick links',
        items: [
          {
            link: 'DTO CN Confluence Space',
            href: 'https://atc.bmw-brilliance.cn/confluence/pages/viewpage.action?pageId=370392428',
            target: 'page',
          },
          {
            link: 'China EDM (Enterprise Data Map)',
            href: 'https://edm.bmw.com.cn/',
            target: 'page',
          },
          {
            link: 'China CDH (Cloud Data Hub)',
            href: 'https://data.aws.bmwcn.cloud/',
            target: 'page',
          },
          {
            link: 'AI AM BMW (Global)',
            href: 'https://ai.bmwgroup.net/',
            target: 'page',
          },
        ],
      },
      {
        title: 'Help Center',
        items: [
          {
            link: 'Glossary',
            href: '',
            callback: () => {
              // modal.glossary = true;
              window.open('https://atc.bmw-brilliance.cn/confluence/x/n-KGRg', '_blank');
            },
          },
          {
            link: 'Feedback',
            href: '',
            callback: () => {
              modal.feedback = true;
            },
          },
        ],
      },
    ];
    return () => (
      <div class={styles.footer}>
        <div class={styles.footerIntro}>
          <img src={dtsFooterLogo} draggable={false}></img>
          <div class={styles.desc}>
            DTO China drives the corporate transformation activities towards A “Data & AI driven
            company”. To empower “Data at Your Fingertips” & “AI for Everyone”, DTS is established
            to provide Data & AI knowledge, services and upcoming events. Join us in this wonderful
            journey !
          </div>
        </div>
        <div class={styles.footerContainer}>
          {linkArr.map((l) => (
            <LinkList key={l.title} links={l} />
          ))}
        </div>
      </div>
    );
  },
});

export default Footer;
